<template>
  <div>
    <div class="top-bar">
      <span @click="goBack">
        <i class="left"></i>
      </span>
      <span class="heading_new">Add New Perk</span>
    </div>
    <div class="main-container">
      <!-- <tl-select label="Select Perk" 
        :options="perks" 
        @change="(val)=>{perk=val}"
      /> -->
       <tl-select label="Select Perk" labelText="name" :options="globalDataObj.perk"
             @change="(val)=>{perk=val}" name="Perk" ></tl-select>

      <div v-if="perk=='Company Accommodation Perk'">
        <!-- <div class="label">Rent Period</div> -->
        <div class="filters">
          <div>
            <span class="input-label">From</span>
            <date-picker @datevalue="(val)=>fromdate=val" :value="fromdate" />
          </div>
          <div>
            <span class="input-label">To</span>
            <date-picker @datevalue="(val)=>todate=val" :value="todate" />
          </div>
        </div>
        <div class="loc">
          <span class="input-label">Accomodation Location</span>
          <tl-search/>
        </div>
        <br>
        <span class="label">Type of Accommodation</span>
        <div class="radio">
          <tl-radio name="accomodation" id="owned" label="Employer Owned" value="owned" v-model="accomodation" />
          <tl-radio name="accomodation" id="leased" label="Employer Leased" value="leased" v-model="accomodation" />
        </div>
        <div v-if="accomodation=='leased'">
          <div class="radio">
            <txt label="Monthly rent paid by Employer" />
            <txt label="Monthly rent paid by Employee(If any)" />
          </div>
        </div>
        <br>
        <br>
        <span class="label">Type of Furnishing</span>
        <div class="radio">
          <tl-radio name="furnishing" id="furnished" label="Furnished" value="furnished" v-model="furnishing" />
          <tl-radio name="furnishing" id="unfurnished" label="Un-Furnished" value="unfurnished" v-model="furnishing" />
        </div>
        <br>
        <txt :label="furnishing=='furnished'?'Cost of Furniture':'Rent of Furniture'" />
        <bottom-action-container>
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="goBack" />
            <btn text="Save" :disabled="perk==''" type="primary" @click="save()" />
          </btn-grp>
        </template>
      </bottom-action-container>
      </div>
      <div v-else-if="perk=='Loan Perk'">
        <loanPerk></loanPerk>
      </div>
      <div v-else-if="perk=='Car Perk'">
        <carPerk></carPerk>
      </div>
      <div v-else-if="perk!=''">
        <!-- <span class="label"></span> -->
        <div class="radio">
          <tl-radio name="otherstime" id="monthly" label="Monthly" value="monthly" v-model="otherstime" />
          <tl-radio name="otherstime" id="yearly" label="Yearly" value="yearly" v-model="otherstime" />
        </div>
        <br><br>
        <txt label="Amount" v-model="monthlyamount" type="text" v-if="otherstime=='monthly'"/>
        <txt label="Amount" v-model="yearlyamount" type="text" v-if="otherstime=='yearly'"/>
      <bottom-action-container >
        <template slot="end">
          <btn-grp>
            <btn text="Cancel" type="secondary" @click="goBack" />
            <btn text="Save" :disabled="perk==''" type="primary" @click="save" />
          </btn-grp>
        </template>
      </bottom-action-container>
      </div>
      <pop-up-message v-if="showSuccessMsg" :message="`${perk} submitted successfully.`" btnText="Ok" @back="okbtn()" />

    </div>
  </div>
</template>

<script>
import loanPerk from "./loanPerk/loanPerk.vue";
import carPerk from "./carPerk/carPerk.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import ToastMessage from "@/components/ToastMessage.vue";

export default {
  name: "newPerk",
  components: {
    loanPerk,
    carPerk
  },
  data() {
    return {
      perk: "",
      fromdate: "",
      todate: "",
      accomodation: "owned",
      furnishing: "furnished",
      showSuccessMsg: false,
      perks: [
      ],
      otherstime: "monthly",
      monthlyamount: "",
      yearlyamount: ""
    };
  },

  activated() {
    
  },
  computed: {

    ...mapState({
      globalDataObj: state => state.globalapi.globalData.data,
    })
    
  },

  methods: {
    ...mapActions({
    }),

    goBack() {
      this.$router.go(-1);
    },
    save() {
      this.showSuccessMsg = true;
    },
    okbtn() {
      this.showSuccessMsg = false;
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.top-bar {
  height: auto;
  padding: 20px;
  background-color: #34c0be;
  display: flex;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.heading_new {
  width: auto;
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}

.loc {
  margin-top: 20px;
}

.radio {
  display: flex;
  padding-top: 15px;
  div {
    padding-right: 20px;
  }
}

.footer-width {
  width: 90%;
}
</style>